
import { AfterViewInit, Component, HostBinding, Inject, Input, OnDestroy } from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";
import { Observable ,  Subscription } from "rxjs";
import { map } from "rxjs/operators";

import { ImmutableRedux } from "../../../redux/immutable-redux.service";
import { CommonFormManagerDirective } from "../form-manager.directive";
import { FORM_CTAS_STATE_PROP } from "../state-props";
import { formCtasReducerFactory } from "./reducer";

interface IFormCtaState {
    isFormVisible: boolean;
}

@Component({
    selector: "form-ctas-control",
    templateUrl: "./form-ctas.component.html",
    styleUrls: ["../../../styles/_utilities.colors.scss"],
})
export class CommonFormCtasComponent implements OnDestroy, AfterViewInit {
    @HostBinding("style.cursor") public cursorStyle = "pointer";
    @Input("stateProp") public statePropInput: string;
    @Input() public ctaLabel: string;
    @Input() public ctaIcon: string;
    @Input() public iconText: string;
    @Input() public ctaDisabled = false;
    @Input("buttonType") public buttonTypeInput = "primary";
    @Input("buttonSize") public buttonSizeInput = "";
    @Input() public buttonColor;
    @Input() @BooleanAttribute() public ctaTooltip = false;
    @Input() public isFormVisibleByDefault = false;
    @Input() public formManager: CommonFormManagerDirective;

    public showTooltip = false;

    private state$: Subscription;
    public state: IFormCtaState = {
        isFormVisible: this.isFormVisibleByDefault,
    };

    public isFormVisible$: Observable<boolean>;
    public get isFormVisible() {
        return this.state.isFormVisible;
    }

    public set isFormVisible(isFormVisible) {
        this.state.isFormVisible = isFormVisible;
    }

    constructor(
        public ngRedux: ImmutableRedux<any>,
        @Inject(FORM_CTAS_STATE_PROP) public rootProp,
    ) { }

    public ngAfterViewInit() {
        this.ngRedux.registerComponent(
            formCtasReducerFactory,
            this.rootProp,
            this.stateProp,
            this.state,
        );

        this.state$ = this.ngRedux.select(this.rootProp, this.stateProp).subscribe((state) => {
            this.state = state;
        });

        this.isFormVisible$ = this.ngRedux.select(this.rootProp, this.stateProp).pipe(map((state) => state.isFormVisible));
    }

    public ngOnDestroy() {
        this.state$.unsubscribe();
    }

    public get stateProp() {
        if (this.formManager) { return this.formManager.stateProp; }
        return this.statePropInput;
    }

    public get label() {
        return this.ctaLabel;
    }

    public get icon() {
        return this.ctaIcon;
    }
    public get text() {
        return this.iconText;
    }
    public get buttonType() {
        return this.buttonTypeInput;
    }

    public get buttonSize() {
        return this.buttonSizeInput;
    }

    public get isInvalid() {
        return this.formManager ? !this.formManager.isValid : false;
    }
}
